import { Svg, Path } from "@react-pdf/renderer";

const Warning = ({ size = 20 }) => (
  <Svg
    width={size}
    height={size}
    viewBox="0 0 26 26"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <Path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M10.983 20.5882C10.983 19.4736 11.8862 18.5706 13.0002 18.5706C14.1141 18.5706 15.017 19.4736 15.017 20.5882C15.017 21.7014 14.1141 22.6052 13.0002 22.6052C11.8862 22.6052 10.983 21.7014 10.983 20.5882ZM11.4874 8.48558C11.4874 7.65069 12.1647 6.97252 13.0002 6.97252C13.8353 6.97252 14.5129 7.65069 14.5129 8.48558V14.5364C14.5129 15.373 13.8353 16.0498 13.0002 16.0498C12.1647 16.0498 11.4874 15.373 11.4874 14.5364V8.48558ZM25.7879 21.6587L25.7008 21.5139C25.6922 21.4995 25.6844 21.4848 25.6755 21.4705L14.6107 2.56748C14.2894 2.00873 13.6935 1.625 13.0002 1.625C12.2222 1.625 11.5592 2.10341 11.2822 2.78086L0.398446 21.3812C0.152452 21.696 0 22.0877 0 22.5177C0 23.5444 0.831523 24.375 1.85763 24.375H24.1424C25.1678 24.375 26 23.5444 26 22.5177C26 22.2071 25.9161 21.9191 25.7819 21.662L25.7879 21.6587Z"
      fill="#FBAB18"
    />
  </Svg>
);

export default Warning;
